import { useSiteContext } from '@eti/providers';
import { useEffect, useRef } from 'react';
import { css } from '@eti/styles';
import { createScript, removeScript } from '../utils/script';
import { jsx as _jsx } from "react/jsx-runtime";
const ratingWidgetStyle = css`
  height: 20px;
  margin-top: 16px;
  position: relative;
  width: 230px;

  iframe {
    height: 100%;
    left: -7px;
    width: 100%;
  }
`;
export const TrustpilotWidget = _ref => {
  let {
    businessId
  } = _ref;
  const trustBoxRef = useRef(null);
  const {
    language
  } = useSiteContext();
  useEffect(() => {
    const onScriptLoad = () => {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(trustBoxRef.current);
      }
    };
    if (trustBoxRef.current && !window.Trustpilot) {
      createScript(businessId, 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', onScriptLoad);
    } else {
      window.Trustpilot.loadFromElement(trustBoxRef.current);
    }
    return () => {
      removeScript(businessId);
    };
  }, [businessId]);
  return /*#__PURE__*/_jsx("div", {
    className: ratingWidgetStyle,
    "data-businessunit-id": businessId,
    "data-locale": language.locale,
    "data-template-id": "5419b637fa0340045cd0c936",
    "data-theme": "light",
    ref: trustBoxRef
  });
};